import React from "react";
import Completion from "../misc/temp/Completion";
import UnderConstruction from "../misc/temp/UnderConstruction";

const Resume = () => {
    return (
        <>
            <Completion percentage="2" status="not initialized" />
            <UnderConstruction name="Resume Section" />
        </>
    );
};

export default Resume;
